import React, {Fragment} from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { changePort } from 'actions/regions/ports';
import {Field, formValueSelector} from "redux-form";
import {TextField} from "redux-form-material-ui";
import { formName } from 'data/formNames';
import constants from "constants";
import MapComponent from './MapComponent';
import { addValidator, required, numericality } from 'redux-form-validators';

const styles = {
    textField: {
        floatingLabelStyle: {
            fontSize: '12px',
        }
    },
    icon: {
        color: 'rgb(0, 188, 212)'
    },
};

class Coordinates extends React.Component {
    constructor(props) {
        super(props);

    }

    render() {
        const { coordinates, change } = this.props;

        return (
            <Fragment>
                <div className="row">
                    <div className="col-xs-4">
                        <Field
                            component={TextField}
                            name={'coordinates[1]'}
                            floatingLabelText='Latitude'
                            floatingLabelStyle={styles.textField.floatingLabelStyle}
                            fullWidth
                            validate={[required(), numericality({ '<=': 90, '>=': -90 }) ]}
                        />
                        <Field
                            component={TextField}
                            name={'coordinates[0]'}
                            floatingLabelText='Longitute'
                            floatingLabelStyle={styles.textField.floatingLabelStyle}
                            validate={[required(), numericality({ '<=': 180, '>=': -180 }) ]}
                            fullWidth
                        />
                    </div>
                    <div className="col-xs-8">
                        <MapComponent
                            coordinates={coordinates}
                            change={change}
                            googleMapURL={`https://maps.googleapis.com/maps/api/js?key=${constants.GOOGLE_MAP_API_KEY}`}
                            loadingElement={<div style={{ height: `100%` }} />}
                            containerElement={<div style={{ width: '100%', height: `300px` }} />}
                            mapElement={<div style={{ height: `100%` }} />}
                        />
                    </div>
                </div>
            </Fragment>
        );
    }
}

Coordinates.propTypes = {

};

Coordinates.defaultProps = {

};

const selector = formValueSelector(formName.portCreate);
export default connect(
    (state, ownProps) => {
        return {
            ...ownProps,
            coordinates: selector(state, 'coordinates'),
        };
    },
    dispatch => bindActionCreators({
        changePort,
    }, dispatch),
)(Coordinates);


// WEBPACK FOOTER //
// ./app/components/Regions/PortAdd/Coordinates.jsx